<div class="ng-data-picker flex-box">
  <!-- picker-group-layer -->
  <div #pickerGroupLayer *ngFor="let group of data; let gIndex = index"
       class="picker-group" [ngClass]="getGroupClass(gIndex)">

    <div class="picker-list">
      <div *ngIf="group.divider; else elseBlock"
           class="picker-item divider" [ngClass]="getItemClass(gIndex, null, true)">
        {{ group.text }}
      </div>
      <ng-template #elseBlock>
        <div  *ngFor="let item of group.list; let iIndex = index"
             class="picker-item" [ngClass]="getItemClass(gIndex, iIndex)" [ngStyle]="getItemStyle(gIndex, iIndex)">
          {{ item.value || item }}
        </div>
      </ng-template>

    </div>

  </div>

  <div #pickerHandleLayer class="picker-handle-layer flex-box dir-column">
    <div data-type="top" class="picker-top weight-1"></div>
    <div data-type="middle" class="picker-middle"></div>
    <div data-type="bottom" class="picker-bottom weight-1"></div>
  </div>
</div>
